import React from 'react';
import { Reservation, ReservationStatus } from '@core/models';
import { LoadingOutlined } from '@ant-design/icons';
import { useReservationStatusColor, useReservationStatusText } from '@utils/reservation.util';

function ReservationStatusBadge<T>({
  reservation,
  style,
}: {
  reservation: Reservation<T>;
  style?: React.CSSProperties;
}) {
  const renderReservationStatusColor = useReservationStatusColor();
  const renderedText = useReservationStatusText();
  return (
    <div
      style={{
        backgroundColor: renderReservationStatusColor(reservation),
        width: 'fit-content',
        color: 'white',
        padding: '3px 7px',
        fontSize: '12px',
        borderRadius: 5,
        cursor: 'pointer',
        fontWeight: 600,
        ...style,
      }}>
      {reservation.status === ReservationStatus.InProgress && (
        <LoadingOutlined style={{ marginRight: 10 }} />
      )}
      <React.Fragment>{renderedText(reservation)} </React.Fragment>
    </div>
  );
}

export default ReservationStatusBadge;
